<div>
  <!--<h2>
    Image Viewer
  </!->-->
  <div *ngIf="isLoading; else showimage">
    Loading ....
  </div>
  <ng-template #showimage>
    <app-image-viewer [images]="docImages"
                      [idContainer]="'idOnHTML'"
                      [loadOnInit]="true"
                      [showPDFOnlyOption]="false"
                      (onNext)="getNextImage($event)"></app-image-viewer>

  </ng-template>
</div>
